import { SERVICES, PROJECTS, SOLUTIONS, SETTINGS } from "@/data/content";

const ok = (data) => ({ data, isLoading: false, isError: false });
const missing = () => ({ data: undefined, isLoading: false, isError: true });

export function useServices() { return ok(SERVICES); }
export function useService(slug) {
  const item = SERVICES.find((s) => s.slug === slug);
  return item ? ok(item) : missing();
}
export function useProjects() { return ok(PROJECTS); }
export function useProject(slug) {
  const item = PROJECTS.find((p) => p.slug === slug);
  return item ? ok(item) : missing();
}
export function useSolutions() { return ok(SOLUTIONS); }
export function useSettings() { return ok(SETTINGS); }
